module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_8003.e6813c09.png";